import script from "./PandoraSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraSelect.vue?vue&type=script&setup=true&lang=js"

import "./PandoraSelect.vue?vue&type=style&index=0&id=697aa098&lang=css"

const __exports__ = script;

export default __exports__